module.exports = __webpack_public_path__ + "img/经典面膜.5c0ac6c3.jpg";